/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useSelector } from "react-redux";
import { withTranslation } from "react-i18next";

import { Label, UncontrolledTooltip } from "reactstrap";

//import Select from "react-select";
import Switch from "react-switch";

// Custom methods
import { isFunction } from "../../../Libs/CustomMethods/customMethods";

// Theme style
import "./lightTheme.scss";

const importDarkMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./darkTheme.scss");
  }
};

const ChatEvent = ({ t, disabled, onChange, ...props }) => {
  const { mainTheme } = useSelector((state) => state.Layout);

  importDarkMode(mainTheme);

  const style = {
    width: props?.width ?? "auto",
    ...props?.style,
  };

  const toggleSwitch = () => {
    if (!disabled && isFunction(onChange)) onChange(!props.value)
  };

  const tooltips = () => {
    if(!props?.tooltip){
      return;
    }
    return (
      <UncontrolledTooltip placement="bottom" target={`eventInfo-${props?.id}`}>
        {t(props?.tooltip)}
      </UncontrolledTooltip>
    );
  };

  const title = () => {
    return (
      <div className="d-flex justify-content-between w-100">
        <Label className="d-flex control-label font-weight-bold align-items-center pr-2">
          {t(props?.title ?? "")}
          {
            props?.tooltip && (           
            <i
              className="fas fa-info-circle px-2 pointer"
              id={`eventInfo-${props?.id}`}
            ></i>
            )
          }
        </Label>
        <div>
          <div onClick={toggleSwitch}>
            <Switch
            ref={props?.ref ?? null}
              id={`eventToggle-${props?.id}`}
              className="chat-event-switch d-flex align-self-center"
              onColor="#34c38f"
              offColor="#bfc8e2"
              onHandleColor="#222736"
              offHandleColor="#32394E"
              handleDiameter={10}
              width={28}
              height={16}
              checkedIcon={false}
              uncheckedIcon={false}
              checked={!!props?.value}
              disabled
              onChange={() => {}}
            />
          </div>
        </div>
        {tooltips()}
      </div>
    );
  };

  return (
    <>
      <div className="chatEvent d-flex flex-column rounded p-3" style={style}>
        <div className="d-flex align-items-center mb-2">{title()}</div>
        <div className="d-flex align-items-center mb-2"></div>
      </div>
    </>
  );
};

export default withTranslation()(React.memo(ChatEvent));
